// app entry
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { BetSlipProvider } from "./components/feature/BetSlipContext";
import BetSlipPanel from "./components/feature/BetSlipPanel";
import MobileBetSlipButton from "./components/feature/MobileBetSlipButton";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <BetSlipProvider>
          <AppRoutes />
          <BetSlipPanel />
          <MobileBetSlipButton />
        </BetSlipProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
